import { ChangeDetectionStrategy, Component, forwardRef, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { SlotComponent } from '../slot.component';
import { SlotTooltipPipe, TranslationKeyPipe, DelayDisplayImpurePipe } from '../../../pipes';
import { LayoutDirective } from '../../../directives';
import { ComponentsModule, slideDown } from '../../../../../lib';
import { VisualComponent } from '../../visual/visual.component';

@Component({
    selector: 'ca-slot-inline-radio-button',
    templateUrl: './slot-inline-radio-button.component.html',
    styleUrls: ['./slot-inline-radio-button.component.scss'],
    imports: [
        CommonModule,
        LayoutDirective,
        MatRadioModule,
        TranslationKeyPipe,
        SlotTooltipPipe,
        DelayDisplayImpurePipe,
        ComponentsModule,
        VisualComponent
    ],
    animations: [slideDown],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SlotInlineRadioButtonComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlotInlineRadioButtonComponent extends SlotComponent {
    ariaLabel = input<string>('');

    override writeValue(value: any): void {
        this.value.set(value);
    }

    onValueChange(value: any) {
        if (!this.isDisabled) {
            this.value.set(value);
            this.onChange(value);
        }
    }
}
